<template>
    <div class="swipe-box swipe-content">
      <div class="notify">
        <van-notice-bar
            left-icon="volume-o"
            :text="notify"
            color="#1989fa" background="#ecf9ff"
        />
      </div>
      <van-swipe :autoplay="3000" class="swipe-item-info">
        <van-swipe-item v-for="(image, index) in images" :key="index" >
          <van-image width="100%" height="10rem"  :src="image.syimgurl"/>
        </van-swipe-item>
      </van-swipe>
      </div>
</template>

<script>

export default {
  data:  function() {
    return {
      notify:"尊敬的司机师傅们，欢迎来到苏豪丽天智储！我们始终秉持“专业为本、服务至上、安全第一”的理念，已全面做好准备，为您提供高效、规范、贴心的一站式服务。"

    }
    },
  props:{
    images: {
      type: Array,
      default: function() {
        return []
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.swipe-content{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .notify{
    width: 95%;
    margin:5px 0;
    border-radius: 10px;
  }
  .swipe-item-info{
    margin-top: 10px;
    width: 95%;
    border-radius: 10px;
  }
}
.content {
    .van-swipe-item {
        img {
            width: 100vw;
            height: 9.375rem;
            object-fit: cover;
        }
    }
}
</style>
